import { render, staticRenderFns } from "./LossAnasyle.vue?vue&type=template&id=64d802ba&scoped=true&"
import script from "./LossAnasyle.vue?vue&type=script&lang=ts&"
export * from "./LossAnasyle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d802ba",
  null
  
)

export default component.exports